import React, { useState } from 'react';
import { ChevronDown, Building2, Check, MapPin } from 'lucide-react';
import { useWorkspace } from '../contexts/WorkspaceContext';
export function Header() {
  const {
    currentWorkspace,
    setCurrentWorkspace,
    workspaces,
    currentSubRegion,
    setCurrentSubRegion
  } = useWorkspace();
  const [isTeamOpen, setIsTeamOpen] = useState(false);
  const [isRegionOpen, setIsRegionOpen] = useState(false);
  return <header className="h-16 border-b border-gray-200 bg-white px-4 sm:px-6 lg:px-8 flex items-center justify-between flex-shrink-0" data-id="element-302">
      <div className="flex items-center gap-2 sm:gap-4 min-w-0 flex-1" data-id="element-303">
        <span className="text-sm text-gray-500 hidden sm:inline flex-shrink-0" data-id="element-304">
          Scope:
        </span>

        {/* Team Selector */}
        <div className="relative flex-shrink-0" data-id="element-305">
          <button onClick={() => setIsTeamOpen(!isTeamOpen)} className="flex items-center gap-1 sm:gap-2 px-2 sm:px-3 py-1.5 text-sm font-medium text-gray-900 bg-gray-50 hover:bg-gray-100 rounded-md border border-gray-200 transition-colors whitespace-nowrap" data-id="element-306">
            <Building2 className="h-4 w-4 text-gray-500 flex-shrink-0" data-id="element-307" />
            <span className="truncate max-w-[100px] sm:max-w-[150px]" data-id="element-308">
              {currentWorkspace.name}
            </span>
            <ChevronDown className={`h-4 w-4 text-gray-400 flex-shrink-0 transition-transform ${isTeamOpen ? 'rotate-180' : ''}`} data-id="element-309" />
          </button>

          {isTeamOpen && <>
              <div className="fixed inset-0 z-10" onClick={() => setIsTeamOpen(false)} data-id="element-310" />
              <div className="absolute top-full left-0 mt-2 w-72 bg-white rounded-md shadow-lg border border-gray-200 py-1 z-20 max-h-80 overflow-y-auto" data-id="element-311">
                {workspaces.map(team => <button key={team.id} onClick={() => {
              setCurrentWorkspace(team);
              setCurrentSubRegion(null);
              setIsTeamOpen(false);
            }} className="w-full flex items-center justify-between px-4 py-2.5 text-sm hover:bg-gray-50 transition-colors" data-id="element-312">
                    <div className="flex items-center gap-3 min-w-0" data-id="element-313">
                      <Building2 className="h-4 w-4 text-gray-400 flex-shrink-0" data-id="element-314" />
                      <div className="text-left min-w-0" data-id="element-315">
                        <div className="font-medium text-gray-900 truncate" data-id="element-316">
                          {team.name}
                        </div>
                        <div className="text-xs text-gray-500 truncate" data-id="element-317">
                          {team.region}
                        </div>
                      </div>
                    </div>
                    {currentWorkspace.id === team.id && <Check className="h-4 w-4 text-blue-600 flex-shrink-0" data-id="element-318" />}
                  </button>)}
              </div>
            </>}
        </div>

        <span className="text-gray-300 flex-shrink-0" data-id="element-319">/</span>

        {/* Subregion Selector */}
        <div className="relative flex-shrink-0" data-id="element-320">
          <button onClick={() => setIsRegionOpen(!isRegionOpen)} className="flex items-center gap-1 sm:gap-2 px-2 sm:px-3 py-1.5 text-sm font-medium text-gray-900 bg-gray-50 hover:bg-gray-100 rounded-md border border-gray-200 transition-colors whitespace-nowrap" data-id="element-321">
            <MapPin className="h-4 w-4 text-gray-500 flex-shrink-0" data-id="element-322" />
            <span className="truncate max-w-[80px] sm:max-w-[120px]" data-id="element-323">
              {currentSubRegion || 'All Regions'}
            </span>
            <ChevronDown className={`h-4 w-4 text-gray-400 flex-shrink-0 transition-transform ${isRegionOpen ? 'rotate-180' : ''}`} data-id="element-324" />
          </button>

          {isRegionOpen && <>
              <div className="fixed inset-0 z-10" onClick={() => setIsRegionOpen(false)} data-id="element-325" />
              <div className="absolute top-full left-0 mt-2 w-64 bg-white rounded-md shadow-lg border border-gray-200 py-1 z-20 max-h-80 overflow-y-auto" data-id="element-326">
                <button onClick={() => {
              setCurrentSubRegion(null);
              setIsRegionOpen(false);
            }} className="w-full flex items-center justify-between px-4 py-2.5 text-sm hover:bg-gray-50 transition-colors" data-id="element-327">
                  <span className="font-medium text-gray-900" data-id="element-328">All Regions</span>
                  {!currentSubRegion && <Check className="h-4 w-4 text-blue-600 flex-shrink-0" data-id="element-329" />}
                </button>
                {currentWorkspace.subRegions.length > 0 && <div className="border-t border-gray-100 my-1" data-id="element-330" />}
                {currentWorkspace.subRegions.map(region => <button key={region} onClick={() => {
              setCurrentSubRegion(region);
              setIsRegionOpen(false);
            }} className="w-full flex items-center justify-between px-4 py-2.5 text-sm hover:bg-gray-50 transition-colors" data-id="element-331">
                    <span className="font-medium text-gray-900 truncate" data-id="element-332">
                      {region}
                    </span>
                    {currentSubRegion === region && <Check className="h-4 w-4 text-blue-600 flex-shrink-0" data-id="element-333" />}
                  </button>)}
                {currentWorkspace.subRegions.length === 0 && <div className="px-4 py-2 text-xs text-gray-500 italic" data-id="element-334">
                    No sub-regions defined
                  </div>}
              </div>
            </>}
        </div>
      </div>

      <div className="flex items-center gap-4 flex-shrink-0 ml-4" data-id="element-335">
        <span className="hidden sm:inline-flex items-center rounded-md bg-blue-50 px-2 py-1 text-xs font-medium text-blue-700 ring-1 ring-inset ring-blue-700/10 whitespace-nowrap" data-id="element-336">
          Super Admin View
        </span>
      </div>
    </header>;
}